"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FetchError = /** @class */ (function (_super) {
    __extends(FetchError, _super);
    function FetchError(message, status, statusText) {
        if (status === void 0) { status = 0; }
        if (statusText === void 0) { statusText = ''; }
        var _this = _super.call(this, message) || this;
        _this.status = status;
        _this.statusText = statusText;
        return _this;
    }
    return FetchError;
}(Error));
exports.default = FetchError;
//# sourceMappingURL=fetch-error.js.map